/* eslint-disable array-callback-return */
/* eslint-disable @typescript-eslint/no-unused-vars */
import { ActionTypes } from '../../actions/action';
import { IRoleRes } from './types';


const initialState: IRoleRes = {
    items: [],
    totalCount: 0,
    optionList: [],
};

const rolesReducers = (state: IRoleRes = initialState, action): IRoleRes => {
  switch (action.type) {
    case ActionTypes.ROLE_LIST:{
      const optionList = action.payload?.items?.map((item: any, index: any)=>{
        return{
          value: item.id,
          label: item.role_name,
        }
      })
      return {
        ...state,
        ...action.payload,
        optionList: optionList
      };
    }
    case ActionTypes.ADD_ROLE:{
      const items = [];
      items.push(action?.payload);
      state?.items?.map((item, index)=>{
        items.push(item);
      })
      const totalCount = state?.totalCount + 1;
      return {
        ...state,
        items: items,
        totalCount: totalCount,
      };
    }
    case ActionTypes.UPDATE_ROLE:{
      const updatedList = state?.items.map(role =>
        role.id === action.payload.id ? action.payload : role
      );
      return {
        ...state,
        items: updatedList,
      };
    }
    case ActionTypes.DELETE_ROLE:{
      const updatedList = state.items.filter(role => role.id !== action.payload.id);
      const totalCount = state?.totalCount - 1;
      return {
        ...state,
        items: updatedList,
        totalCount: totalCount
      };
    }
    case ActionTypes.ADMIN_LOGOUT:{
      return initialState
    }
    default:
      return state;
  }
};

export default rolesReducers;
